var data = {
	"body": "<path d=\"M2.81 14.12l2.83-2.83l2.53-.5c3.22-4.38 9.38-6.57 11.61-6.57c0 2.23-2.19 8.39-6.57 11.61l-.5 2.53l-2.83 2.83l-.71-3.53c-1.41 0-1.41 0-2.12-.71c-.71-.71-.71-.71-.71-2.12l-3.53-.71m2.83 2.83l1.41 1.41l-2.66 2.67H2.97v-1.42l2.67-2.66m-1.42-1.41l1.24.17L3 18.16v-1.42l1.22-1.2m4.07 3l.17 1.24L7.26 21H5.84l2.45-2.46M13 9.5a1.5 1.5 0 0 0-1.5 1.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5A1.5 1.5 0 0 0 13 9.5z\" fill=\"currentColor\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@iconify/icons-mdi/rocket.js
// module id = 1431
// module chunks = 0